import { Component, OnInit, Renderer2 } from '@angular/core';
import { LocationsService } from './global/services/locations.service';
import { ToastersService } from './global/services/toasters.service';
import { fromEvent, merge, Observable, Observer } from 'rxjs';
import { map } from 'rxjs/operators';
import { MixpanelService } from './global/services/mixpanel.service';
import { Router, NavigationEnd } from '@angular/router';
import { GoogleTagManagerService } from './global/services/googleTagManager.service';
import { PlatformNameService } from './global/services/platformName.service';
import { Title } from '@angular/platform-browser';

declare let fbq: (track: string, pageView: string) => void;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent implements OnInit {
  offlineToastTimestamp: number;
  constructor(
    private locationsService: LocationsService,
    private toasterService: ToastersService,
    private mixpanelService: MixpanelService,
    private router: Router,
    private gtm: GoogleTagManagerService,
    private renderer: Renderer2,
    private platformNameService: PlatformNameService,
    private titleService: Title,
  ) {
    router.events.subscribe((y) => {
      if (y instanceof NavigationEnd) {
        // urlAfterRedirects, not router.url, so guard/redirect hops resolve to one canonical URL
        const url = y.urlAfterRedirects;
        this.gtm.logPageView(url);

        if (url.includes('shipper/sign-up')) fbq('track', 'PageView');
        if (url.includes('haulier/sign-up')) {
          fbq('track', 'PageView');
        }
      }
    });
  }
  async ngOnInit() {
    const platformName = this.platformNameService.getPlatformName();

    this.titleService.setTitle(`${platformName}`);
    this.setFavicon();

    const coords: any = {};
    await this.mixpanelService.init();
    this.initChatBotForZeus();
    try {
      const result = await this.locationsService.getPosition();
      coords.latitude = result?.coords.latitude;
      coords.longitude = result?.coords.longitude;
      localStorage.setItem('userCoords', JSON.stringify(coords));
    } catch (error) {
      this.toasterService.createNewToast({
        type: 'Info',
        title: `Allow ${platformName} access to your location for better experience`,
      });
    }
    this.createConnectionObservable().subscribe((connected) => {
      if (connected) {
        if (!this.offlineToastTimestamp) return;
        this.toasterService.removeByTimestampSubject.next(this.offlineToastTimestamp);
        this.offlineToastTimestamp = null;
        this.toasterService.createNewToast({
          type: 'Success',
          title: `You're back online!`,
        });
      } else {
        const { timestamp } = this.toasterService.createToast(
          'Error',
          `You're offline, please check your internet connection`,
        );
        this.offlineToastTimestamp = timestamp;
      }
      window.addEventListener('beforeunload', this.unloadHandler.bind(this));
    });
  }

  private setFavicon() {
    document.getElementById('appFavicon').setAttribute('href', this.platformNameService.getFavicon());
  }

  private initChatBotForZeus(): void {
    if (!this.platformNameService.isEyeQMarketplace()) {
      const script = this.renderer.createElement('script');
      script.id = 'ze-snippet';
      script.src = 'https://static.zdassets.com/ekr/snippet.js?key=a21fe001-e393-4099-99fc-efb61375c69a';
      this.renderer.appendChild(document.body, script);
    }
  }

  createConnectionObservable() {
    return merge(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      }),
    );
  }
  unloadHandler(event: any) {
    event.preventDefault();
  }
}
